import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook
import { motion } from 'framer-motion';
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import TabbedFormComponent from '../../common/TabbedFormComponent';
import AdvancedDataTableComponent from '../../common/AdvancedDataTableComponent';
import { fetchClientData } from '../../../services/adminApiService';
import { registerServiceTypeTitles, fetchColumnNames, fetchTitlesByServiceTypeId, fetchServiceTypeData, downloadTitlesExcel, fetchServiceTypeTemplateData } from '../../../services/client/serviceTypeApiService'; // Adjust the path as necessary
import FloatingLabelInput from '../../ui/FloatingLabelInput';
import FloatingLabelSelect from '../../ui/FloatingLabelSelect';
import CustomPickList from '../../common/CustomPickList';
import CustomNotification from '../../common/CustomNotification';


const ServiceTypeTemplateForm = () => {
    const [formValues, setFormValues] = useState({
        clientId: '',
        serviceTypeId: '',
        serviceType: '',
        titles: [],
        defaultTitles: []
    });
    const [apiResponse, setApiResponse] = useState(null);
    const [clients, setClients] = useState([]);
    const [serviceTypes, setServiceTypes] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [update, setUpdate] = useState(false);

    const [columns, setColumns] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [availableColumns, setAvailableColumns] = useState([]);  // 'columns' should be the original list
    const mandatoryColumnNames = [ "Check ID", "Component", "Candidate Name"];
    const fetchColumns = async () => {
        try {
            const data = await fetchColumnNames();
            setColumns(data);
            setAvailableColumns(data);
            setSelectedColumns([]);
        } catch (error) {
            console.error("Error fetching clients:", error);
        }
        // const data = [
        //     "Case ID", "Component", "Candidate Name", "Status", "Priority", "Due Date"
        // ];
        
    };

    useEffect(() => {
        fetchColumns();
    }, []);
    
    const handleSelectionChange = (newAvailableColumns, newSelectedColumns) => {
        if (!formValues.clientId || !formValues.serviceType) {
            alert("Please select Required fields");
            return;
        }
        setAvailableColumns(newAvailableColumns);
        setSelectedColumns(newSelectedColumns);

        setFormValues({ ...formValues, titles: newSelectedColumns });
    };
      

    const inputClasses = (field) =>
        errors[field] ? 'border-red-500' : 'border-gray-300';

    const getClients = async () => {
        try {
            const clientData = await fetchClientData();
            setClients(clientData.map(client => ({ value: client.clientId, label: client.clientName })));
        } catch (error) {
            console.error("Error fetching clients:", error);
        }
    };
    useEffect(() => {
        // Set default titles only if titles are empty (initial render or no titles selected)
        //console.log("Get Clients Called.......");
        getClients();
    }, []);

    // Handle client selection
    const handleClientChange = (option) => {
        const selectedClientId = option.value;
        setFormValues({ ...formValues, clientId: option.value, serviceTypeId: '' });
        fetchServiceTypeByClient(selectedClientId);
    };

    const fetchServiceTypeByClient = async (clientId) => {
        try {
            const data = await fetchServiceTypeData(clientId);
            setServiceTypes(data.map(obj => ({ value: obj.serviceTypeId, label: obj.serviceType })));
        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };

    const handleBlur = (field) => {
        const validationErrors = validate();
        setErrors(validationErrors);
    };



    const handleServiceTypeChange = (option) => {

        setFormValues((prevFormValues) => ({
            ...prevFormValues,
            serviceTypeId: option.value,
            serviceType: option.label, // Store the selected label if necessary
        }));

        // Fetch titles after updating state
        fetchTitlesByServiceType(option.value);
    };



    const fetchTitlesByServiceType = async (serviceTypeId) => {
        try {
            const titlesData = await fetchTitlesByServiceTypeId(serviceTypeId);
            if (titlesData == null) {
                setFormValues((prevFormValues) => ({
                    ...prevFormValues,
                    titles: [] // Assuming titlesData is an array of objects with a 'title' field
                }));
                setSelectedColumns([]);
                setUpdate(false);
            } else {
                // Update formValues with fetched titles
                setFormValues((prevFormValues) => ({
                    ...prevFormValues,
                    titles: titlesData.map(obj => obj) // Assuming titlesData is an array of objects with a 'title' field
                }));
               // Set selectedColumns based on titlesData
            const newSelectedColumns = titlesData.map(obj => obj);

            // Set availableColumns by excluding selectedColumns from allColumns
            const newAvailableColumns = columns.filter(column => 
                !newSelectedColumns.some(selected => selected === column)
            );

            setSelectedColumns(newSelectedColumns);
            setAvailableColumns(newAvailableColumns);
                setUpdate(true);
            }

        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };



    // Validate form fields
    const validate = () => {
        const newErrors = {};
        if (!formValues.serviceType) newErrors.serviceType = 'Service Type is required';
        if (!formValues.clientId) newErrors.clientId = 'Organization is required';
        if (formValues.titles.some(title => title.trim() === '')) newErrors.titles = 'All titles are required';
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length === 0) {
            setLoading(true);
            try {
                //console.log(formValues);
                 // Check if all mandatory columns are selected
        const missingColumns = mandatoryColumnNames.filter(col => !formValues.titles.includes(col));

        if (missingColumns.length > 0) {
            // If missing columns, show an error message
            setApiResponse({ error: `The following mandatory columns are missing: ${missingColumns.join(', ')}`});
        }else{
           // return;
            const data = await registerServiceTypeTitles(formValues); // Adjust for update if editing
            //onServiceTypeUpdated(data);
            //setFormValues({ clientId: '', serviceTypeId: '', serviceType: '', titles: [] }); // Reset form
            if (data.success) {
                //alert(data.success);
                setApiResponse({ success: data.success});
                await downloadTitlesExcel(formValues.serviceTypeId, formValues.serviceType);
            } else {
                setApiResponse({ error: data.error});
                console.error(data.error);
            }
        }
               
            } catch (error) {
                console.error('Submission error:', error);
            } finally {
                setLoading(false);

            }
        } else {
            setErrors(validationErrors);
        }
    };

    const closeNotification = () => {
        setApiResponse(null);
      };

    return (
        <div className="container mx-auto p-6 bg-white rounded-lg border">
            <form onSubmit={handleSubmit} className="space-y-6 w-full">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                        {loading ? (
                            <p>Loading countries...</p>
                        ) : (
                            <FloatingLabelSelect
                                label="Select Organization"
                                id="clientId"
                                name="clientId"
                                value={clients.find(client => client.value === formValues.clientId) || null} // Handle no selection case with null
                                onChange={handleClientChange}//,{(option) => setFormValues({ ...formValues, clientId: option.value })}
                                onBlur={() => handleBlur('clientId')}
                                className={inputClasses('clientId')}
                                options={clients}
                                isSearchable={true}
                            />
                        )}
                        {errors.clientId && <div className="text-red-500 text-sm">{errors.clientId}</div>}
                    </div>

                    <div>
                        <>
                            {loading ? (
                                <p>Loading ServiceTypes...</p>
                            ) : (


                                <FloatingLabelSelect
                                    label="Select serviceType"
                                    id="serviceTypeId"
                                    name="serviceTypeId"
                                    value={serviceTypes.find(st => st.value === formValues.serviceTypeId) || null}
                                    onChange={handleServiceTypeChange}

                                    onBlur={() => handleBlur('serviceTypeId')}
                                    className={inputClasses('serviceTypeId')}
                                    options={serviceTypes}
                                    isSearchable={true}
                                />


                            )}
                        </>
                        {errors.serviceType && <div className="text-red-500">{errors.serviceType}</div>}
                    </div>

                </div>
                <div className="container mx-auto p-6 bg-white rounded-lg border">
                    {/* <h1 className="text-2xl font-semibold mb-4">Select Columns</h1> */}
                    <CustomPickList
                        availableColumns={availableColumns}
                        selectedColumns={selectedColumns}
                        onSelectionChange={handleSelectionChange}
                        searchable={true}
                    />
                </div>

                {errors.titles && <div className="text-red-500">{errors.titles}</div>}

                {/* Submit Button */}
                <div className="mt-4">
                    <button
                        type="submit"
                        className={`px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 ${loading ? 'opacity-50' : ''}`}
                        disabled={loading}
                    >
                        {loading ? 'Submitting...' : update ? 'Update' : 'Submit'}
                    </button>
                </div>

                {/* {apiResponse && (
                                    <motion.div
                                        className={`mt-4 flex items-center ${apiResponse.error ? 'text-red-500' : 'text-green-500'}`}
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.5 }}
                                    >
                                        {apiResponse.error ? (
                                            <>
                                                <FaExclamationCircle className="mr-2" />
                                                {apiResponse.error}
                                            </>
                                        ) : (
                                            <>
                                                <FaCheckCircle className="mr-2" />
                                                {apiResponse.success}
                                            </>
                                        )}
                                    </motion.div>
                                )} */}
                                {apiResponse && (
                           apiResponse.error ? (         
                  <CustomNotification 
                  autoClose={true}
                  id={1}
                  message={apiResponse.error} 
                  type={'error'}
                  onClose={closeNotification}
                  />   
                ) : ( 
                    <CustomNotification 
                    autoClose={true}
                    id={1}
                    message={apiResponse.success} 
                    type={'success'}
                    onClose={closeNotification}
                    />   
                )
            )  }       
            </form>
        </div>
    );
};


const ServiceTypeTemplatesListTable = ({ onSelectServiceType, switchToFormTab }) => {
    const tableHeaders = ["id", "Organization Name", "Service Type", "CreatedAt"];

    const [list, setList] = useState([]);  // Store Clients

    const [loading, setLoading] = useState(false);

    // Fetch Clients when the component loads
    useEffect(() => {
        const getData = async (cleintId) => {
            try {
                const data = await fetchServiceTypeTemplateData(localStorage.getItem('clientID'));  // Fetch countries from service
                const options = data.map((serviceType) => ({
                    id: serviceType.serviceTypeId,
                    serviceType: serviceType.serviceType,
                    clientId: serviceType.clientId,
                    clientName: serviceType.clientName,
                    createdAt: serviceType.createdAt
                }));
                setList(options);  // Set the countries as options for the select dropdown

            } catch (error) {
                console.error("Error fetching countries:", error);
            } finally {
                // setLoadingCountries(false);  // Stop loading spinner
            }
        };

        getData();
    }, []);


    // Mapping of headers to data keys
    const headerMapping = {
        "id": "id",
        "Organization Name": "clientName", // Maps to the data key 'clientName'
        "Service Type": "serviceType", // Assuming you have 'email' key in your data. If not, replace accordingly
        "CreatedAt": "createdAt" // Maps to the data key 'createdAt'
    };


    const handleDownload = async (rowObject) => {
        try {
            setLoading(true); // Show loading spinner

            await downloadTitlesExcel(rowObject.id, rowObject.serviceType);

        } catch (error) {
            console.error('Error fetching client data:', error);
        } finally {
            setLoading(false); // Hide loading spinner
        }
    };


    return (
        <div className="container mx-auto p-6 bg-white rounded-lg border">
            <AdvancedDataTableComponent
                headers={tableHeaders}
                data={list}
                headerMapping={headerMapping}
                onEdit={handleDownload}
                showActions={true}
                buttonLableName={'Download'}

            />
        </div>
    );

};


const TestPage = () => {

    const [selectedServiceType, setselectedServiceType] = useState(null); // Track selected client for editing
    const [activeTab, setActiveTab] = useState(0); // Track active tab

    const handleEdit = (serviceType) => {
        setselectedServiceType(serviceType);
        setActiveTab(0);
    };
    const handleServiceTypeUpdated = () => {
        setselectedServiceType(null);
    };
    return (<TabbedFormComponent
        formContent={(switchToFormTab) => (
            <ServiceTypeTemplateForm
            />
        )}
        dataTableComponent={(switchToFormTab) => (
            <ServiceTypeTemplatesListTable
                onSelectServiceType={setselectedServiceType}
                switchToFormTab={switchToFormTab}
            />
        )}
    />)
};

export default TestPage;
